import type { Breakpoint } from 'antd';

/**
 * Ant Design responsive breakpoints for file table columns (aligned with Tailwind md/lg/xl).
 * Hide order when narrowing: xl user cols → lg fileSize+tags → md lastModified/deletionDate → title only.
 * Title has no % width so it absorbs leftover space (full-bleed table, no trailing spacer).
 */
export const FILES_TABLE_COLUMN_RESPONSIVE = {
  createdBy: ['xl'] as Breakpoint[],
  deletionDate: ['md'] as Breakpoint[],
  fileSize: ['lg'] as Breakpoint[],
  lastModified: ['md'] as Breakpoint[],
  sharedBy: ['xl'] as Breakpoint[],
  tags: ['lg'] as Breakpoint[],
};

/** Floor when the table is narrow; used with tableLayout that still honors minWidth. */
export const FILES_TABLE_TITLE_MIN_WIDTH = 280;

/**
 * Proportional % shares of table width for secondary columns.
 * Title is intentionally omitted — it absorbs the remainder so columns always fill the viewport
 * (Antd rowSelection checkbox col is separate ~32–48px).
 *
 * compact (no user cols): tags+size+date = 48% → Title ~52%
 * withUsers: tags+size+date+2×user = 60% → Title ~40%
 * Below lg: date keeps its %; Title grows into freed tags/size space
 * Below md: Title only → 100%
 */
export const FILES_TABLE_COLUMN_WIDTH_PERCENT = {
  compact: {
    date: '18%',
    fileSize: '12%',
    tags: '18%',
  },
  withUsers: {
    date: '14%',
    fileSize: '10%',
    tags: '14%',
    user: '11%',
  },
} as const;
